
import { Component, Prop, Vue } from 'vue-property-decorator'
import TicketFwbz from '@/views/Ticket/indexFwbz.vue'

@Component({
  name: 'AllMyCreatedOrderLists',
  components: {
    TicketFwbz
  }
})
export default class extends Vue {}
